import { useApp } from "../../../hooks/useApp"
import { MainProductVariant, SinglePendantProductVariant } from "../../../types"
import { getMainProductVariantById, getOptionalSinglePendantMainProductVariant, getSingleProductVariantFromMainProductByLengthInTitle } from "../../../utils"
import { Text } from "../../ui/Text/Text"
import { formatReadyWord, getProductionDate } from "./utils"

interface Props {
  className?: string
}

const Label = ({ className, label }: { className?: string, label: string }) => {
  return (
    <p className={className}>
      <Text 
        className="font-calibre text-primary"
        style="label"
      >
        {label}
      </Text>
    </p>
  )
}

export const DispatchEstimate = ({ className }: Props) => {
  const { mainProduct, activePendantProductVariantIds, activeMainProductVariantId, isMainProductSinglePendant } = useApp()

  let mainProductVariant: MainProductVariant | SinglePendantProductVariant | undefined;
  switch (true) {
    case isMainProductSinglePendant:
      mainProductVariant = getOptionalSinglePendantMainProductVariant(mainProduct, +activeMainProductVariantId, +activePendantProductVariantIds[0])
      break
    case activePendantProductVariantIds.length === 1:
      mainProductVariant = getSingleProductVariantFromMainProductByLengthInTitle(mainProduct, +activeMainProductVariantId,+activePendantProductVariantIds[0])
      break
    default:
      mainProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)
  }

  if (!mainProductVariant) {
    console.error('Product variant not found to calculate dispatch time', mainProduct, activeMainProductVariantId)
    return <Label className={className} label={`Estimated dispatch on ${getProductionDate(mainProduct)}`} />
  }

  if (!mainProductVariant.available) {
    return null
  }

  if (mainProductVariant.inventoryQuantity > 0) {
    return <Label className={className} label={formatReadyWord()} />
  }

  return <Label className={className} label={`Estimated dispatch on ${getProductionDate(mainProduct)}`} />
}
